import { useTranslation } from 'react-i18next'
import { Button } from '@agion/ui'
import { SUPPORTED_LANGUAGES, languageDisplayName } from '@/services/i18n'

// Kit order; any supported language the kit does not list follows at the end.
const KIT_ORDER = ['en', 'fi', 'sv', 'de', 'fr']
const ORDERED_LANGUAGES = [...SUPPORTED_LANGUAGES].sort(
  (a, b) => (KIT_ORDER.indexOf(a) + 1 || 99) - (KIT_ORDER.indexOf(b) + 1 || 99),
)

/**
 * Language codes at the top of the auth form pane (EN / FI / SV / DE / FR in the kit).
 * The visible label is the ISO code; the accessible name is the language's own name.
 */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation()
  const active = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]

  return (
    <nav className="lp-lang" aria-label={t('login.languageSwitch')}>
      {ORDERED_LANGUAGES.map((lng) => (
        <Button
          key={lng}
          type="button"
          variant="ghost"
          size="sm"
          className="lp-lang-btn"
          aria-pressed={active === lng}
          aria-label={languageDisplayName(lng)}
          lang={lng}
          onClick={() => i18n.changeLanguage(lng)}
        >
          {lng.toUpperCase()}
        </Button>
      ))}
    </nav>
  )
}
